/*
  Formato numérico único del dashboard (auditoría UX: "$19.600" junto a "$2245" y "5.000$").
  Regla: cifras con punto de miles y coma decimal (es-ES), símbolo detrás: 19.600 $ · 433,50 $ · 897 €.
*/
// Idioma de los formatos (05/11/2026): lo fija SiteLangProvider. 'en' = inglés británico: 19,600 · $433.50 · €897 · 2.5%
let LANG = 'es';
export function setFormatLang(l) { LANG = l === 'en' ? 'en' : 'es'; }
export const formatLang = () => LANG;
export const formatLocale = () => (LANG === 'en' ? 'en-GB' : 'es-ES');

const group = (intStr) => intStr.replace(/\B(?=(\d{3})+(?!\d))/g, LANG === 'en' ? ',' : '.');

export function fmtNumber(value, decimals = 0) {
  const n = Number(value) || 0;
  const neg = n < 0;
  const fixed = Math.abs(n).toFixed(decimals);
  const [int, dec] = fixed.split('.');
  return `${neg ? '-' : ''}${group(int)}${dec ? `${LANG === 'en' ? '.' : ','}${dec}` : ''}`;
}

export function fmtMoney(value, currency = 'usd') {
  const n = Number(value) || 0;
  const hasCents = Math.round(n * 100) % 100 !== 0;
  const symbol = String(currency).toLowerCase() === 'eur' ? '€' : '$';
  const num = fmtNumber(n, hasCents ? 2 : 0);
  if (LANG === 'en') return n < 0 ? `-${symbol}${num.slice(1)}` : `${symbol}${num}`;
  return `${num} ${symbol}`;
}

// Divisa del miembro: 'eur' en el EEE, 'usd' fuera (la decide el backend en /my-membership).
// Igual que el backend: cualquier valor que no sea 'eur' se trata como 'usd'.
export function normCurrency(currency) {
  return String(currency || '').toLowerCase() === 'eur' ? 'eur' : 'usd';
}

export function currencySymbol(currency) {
  return normCurrency(currency) === 'eur' ? '€' : '$';
}

// Porcentajes: 15 % · 2,5 % · 0,5 % (recibe el valor ya en %, p. ej. 2.5)
export function fmtPct(value, maxDecimals = 2) {
  const n = Number(value) || 0;
  let fixed = Math.abs(n).toFixed(maxDecimals);
  if (fixed.includes('.')) fixed = fixed.replace(/0+$/, '').replace(/\.$/, '');
  const [int, dec] = fixed.split('.');
  if (LANG === 'en') return `${n < 0 ? '-' : ''}${group(int)}${dec ? `.${dec}` : ''}%`;
  return `${n < 0 ? '-' : ''}${group(int)}${dec ? `,${dec}` : ''} %`;
}

// Precios canónicos que se cobran dentro de la plataforma (anuales, desde el 20/09/2026).
// Deben coincidir con PLANS y LIFETIME_* de backend/routes/memberships.py.
export const MEMBERSHIP_PRICES = {
  usd: { starter: 499, basica: 997, premium: 1497 },
  eur: { starter: 449, basica: 897, premium: 1347 },
};
// Paso a vitalicia (solo PRO y Premium): en el pop-up tras pagar / en los 30 días siguientes
export const LIFETIME_PRICES = {
  usd: { popup: 600, late: 1200 },
  eur: { popup: 500, late: 1000 },
};

// Para ejes de gráficas: 19,6K $
export function fmtMoneyShort(value, currency = 'usd') {
  const n = Number(value) || 0;
  const symbol = String(currency).toLowerCase() === 'eur' ? '€' : '$';
  if (LANG === 'en') return Math.abs(n) >= 1000 ? `${symbol}${fmtNumber(n / 1000, n % 1000 ? 1 : 0)}K` : `${symbol}${fmtNumber(n)}`;
  if (Math.abs(n) >= 1000) return `${fmtNumber(n / 1000, n % 1000 ? 1 : 0)}K ${symbol}`;
  return `${fmtNumber(n)} ${symbol}`;
}
